import React, { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import { ModalContext } from 'modaaals'

import Layout from '../Layout'
import TracksOfTheMonth from './TracksOfTheMonth'
import SyncedItems from './SyncedItems'
import * as Brand from '../Brands'
import * as Icon from '../Icons'
import SliderIcon from './SentenceIcon'
import SelectionContext from '../../context/SelectionContext'
import SentenceSlider from './SentenceSlider'

import CURATED_SELECTION from '../filters/curatedSelection'
import SYNC_SELECTION from '../filters/syncSelection'

import styles from './home.module.css'

function Home() {
  const { openModal } = useContext(ModalContext)
  const [curatedTab, setCuratedTab] = useState(
    Object.keys(CURATED_SELECTION)[0]
  )
  const { selectionState } = useContext(SelectionContext)
  const [syncTab, setSyncTab] = useState('Campaign')

  return (
    <Layout
      hero={
        <>
          <h1 className={styles.title}>
            The Definitive Musical Resource for Advertising, Cinema, Branding,
            Game &amp; more.
          </h1>

          <div className={styles.sliderWrapper}>
            <SliderIcon className={styles.sliderIcon} />
            <SentenceSlider
              sentences={[
                'Carefully curated music for audio and sync licensing. Soundtrack and playlists for any projects.',
                'Pre-cleared rights on hand-picked high profile tracks from renowned international artists.',
                'Tailored for directors, editors, creators and music supervisors. Immediately available for all uses.',
              ]}
            />
          </div>

          <footer className={styles.heroFooterContainer}>
            <section className={styles.heroFooterColumn}>
              <h3 className={styles.heroFooterTitle}>Music supervision</h3>
              <p className={styles.heroFooterText}>
                Our experienced music supervision team offers free professional
                music selections and can help you manage any of your audio
                needs.{' '}
                <button
                  onClick={() => openModal('supervision')}
                  className={styles.link}
                >
                  Ask for our help
                </button>
              </p>
            </section>
            <section className={styles.heroFooterColumn}>
              <h3 className={styles.heroFooterTitle}>Tailored quote</h3>
              <p className={styles.heroFooterText}>
                We have synced with the best creative minds in the world in all
                kind of projects.{' '}
                <button
                  className={styles.link}
                  onClick={() => {
                    if (Object.keys(selectionState).length === 0) {
                      openModal({ type: 'supervision', asEmptyQuote: true })
                    } else {
                      openModal({ type: 'quote', selectionState })
                    }
                  }}
                >
                  Request an immediate quote
                </button>{' '}
                that fits your budget.
              </p>
            </section>

            <section
              className={styles.heroFooterFullWidth}
              style={{
                paddingBottom: 30,
                paddingTop: 40,
                justifyContent: 'space-around',
              }}
            >
              <div className={styles.brandContainer}>
                <div className={styles.animatedBrandLogo}>
                  <Brand.Nike />
                  <Brand.Instagram className={styles.instagram} />
                  <Brand.Mailchimp />
                </div>
                <div
                  className={styles.animatedBrandLogo}
                  style={{ width: 48, '--delay': '4s' }}
                >
                  <Brand.Rockstar />
                  <Brand.LouisVuitton />
                  <Brand.Volkswagen />
                </div>
              </div>
              <div className={styles.brandContainer}>
                <div
                  className={styles.animatedBrandLogo}
                  style={{ '--delay': '6s' }}
                >
                  <Brand.Netflix />
                  <Brand.Vogue />
                  <Brand.Zara />
                </div>
                <div
                  className={styles.animatedBrandLogo}
                  style={{ '--delay': '2s' }}
                >
                  <Brand.Prada />
                  <Brand.Hermes />
                  <Brand.Gucci />
                </div>
              </div>
            </section>

            <section className={styles.heroFooterFullWidth}>
              <Link to="/app" className={styles.heroBigButton}>
                <Icon.Iso className={styles.heroBigButtonIcon} />
                Open Music App
              </Link>
            </section>
          </footer>
        </>
      }
    >
      <section className={cn(styles.featured, styles.width)}>
        <div>
          <h2 className={styles.sectionTitle}>Tracks of the Month</h2>
          <ul className={styles.musicStyles}>
            {Object.keys(CURATED_SELECTION).map((musicStyle) => (
              <li
                key={musicStyle}
                className={cn(styles.musicStyle, {
                  [styles.active]: curatedTab === musicStyle,
                })}
                onClick={() => setCuratedTab(musicStyle)}
              >
                {musicStyle}
              </li>
            ))}
          </ul>

          <TracksOfTheMonth curatedTab={curatedTab} />
        </div>
        <div>
          <h2 className={styles.sectionTitle}>Sync placements</h2>
          <ul className={styles.musicStyles}>
            {Object.keys(SYNC_SELECTION).map((syncItem) => (
              <li
                key={syncItem}
                className={cn(styles.musicStyle, {
                  [styles.active]: syncTab === syncItem,
                })}
                onClick={() => setSyncTab(syncItem)}
              >
                {syncItem}
              </li>
            ))}
          </ul>
          <SyncedItems syncTab={syncTab} openModal={openModal} />
        </div>
      </section>
    </Layout>
  )
}

export default Home
